import _regeneratorRuntime from "D:/Development/Laravel/genic-drive-updated/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/Development/Laravel/genic-drive-updated/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "D:/Development/Laravel/genic-drive-updated/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/Development/Laravel/genic-drive-updated/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.number.to-fixed.js";
import { isObject, isEmpty, identity, pickBy, capitalize, toLower, cloneDeep } from "lodash";
import { ERROR } from "@/core/services/store/common.module";
import Moment from "moment-timezone";
Moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

var validateEmail = function validateEmail(email) {
  //eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

var MainSetting = /*#__PURE__*/function () {
  function MainSetting() {
    _classCallCheck(this, MainSetting);
  }

  _createClass(MainSetting, [{
    key: "install",
    value: function install(Vue) {
      Vue.mixin({
        data: function data() {
          return {
            today: null,
            uniqFieldId: null,
            vrules: {
              required: function required(val, field, isInteger) {
                if (isObject(val) && isEmpty(val)) {
                  return "".concat(field, " is required");
                }

                if (isInteger && parseInt(val) <= 0) {
                  return "".concat(field, " is required.");
                }

                return !!val || "".concat(field, " is required");
              },
              validEmail: function validEmail(val, field) {
                if (val) {
                  if (validateEmail(val)) {
                    return true;
                  }

                  return "".concat(field, " must be valid");
                }

                return true;
              }
            }
          };
        },
        methods: {
          humanFileSize: function humanFileSize(bytes) {
            var si = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var dp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
            var thresh = si ? 1000 : 1024;

            if (Math.abs(bytes) < thresh) {
              return bytes + ' B';
            }

            var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
            var u = -1;
            var r = Math.pow(10, dp);

            do {
              bytes /= thresh;
              ++u;
            } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

            return bytes.toFixed(dp) + ' ' + units[u];
          },
          goBackStepper: function goBackStepper() {
            this.stepper--;
          },
          deepEmpty: function deepEmpty(param) {
            return cloneDeep(pickBy(param, identity));
          },
          isNotEmpty: function isNotEmpty(param) {
            return !isEmpty(param);
          },
          formatBytes: function formatBytes(bytes) {
            var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
            if (bytes === 0) return "0 Bytes";
            var k = 1024;
            var dm = decimals < 0 ? 0 : decimals;
            var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
          },
          formatDateTime: function formatDateTime(dateTime) {
            if (!dateTime) {
              return Moment().format("DD/MM/YYYY hh:mm a");
            }

            return Moment(dateTime).format("DD/MM/YYYY hh:mm a");
          },
          formatDateTimeRaw: function formatDateTimeRaw(dateTime) {
            if (!dateTime) {
              return Moment().format("YYYY-MM-DD HH:mm");
            }

            return Moment(dateTime).format("YYYY-MM-DD HH:mm");
          },
          formatDate: function formatDate(date) {
            if (!date) {
              return Moment().format("DD/MM/YYYY");
            }

            return Moment(date).format("DD/MM/YYYY");
          },
          formatDateRaw: function formatDateRaw(date) {
            if (!date) {
              return Moment().format("YYYY-MM-DD");
            }

            return Moment(date).format("YYYY-MM-DD");
          },
          validateForm: function validateForm(formRef) {
            this.$store.dispatch(ERROR, []);
            var formErrors = [];
            var inputs = formRef.inputs;

            for (var i = 0; i < inputs.length; i++) {
              var errorBucket = inputs[i].errorBucket;

              for (var z = 0; z < errorBucket.length; z++) {
                var errorMessage = capitalize(toLower(errorBucket[z]));
                formErrors.push({
                  model: true,
                  message: errorMessage
                });
              }
            }

            return formErrors;
          },
          goBack: function goBack() {
            this.$router.go(-1);
          },
          logError: function logError(error) {
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      try {
                        console.warn(error);
                      } catch (error) {
                        console.warn(error);
                      }

                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))();
          },
          get_icon: function get_icon(row) {
            if (row.type == "file") {
              return "mdi-file-".concat(row.extension);
            }

            if (row.type == "folder") {
              return "mdi-folder";
            }
          },
          stringUnique: function stringUnique() {
            var result = "";
            var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;

            for (var i = 0; i < 10; i++) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            return result;
          },
          isAlphaNumeric: function isAlphaNumeric(event) {
            var char = String.fromCharCode(event.keyCode);
            if (/^[a-zA-Z0-9 ]+$/.test(char)) return true;else event.preventDefault();
          }
        },
        mounted: function mounted() {
          this.today = Moment().format("YYYY-MM-DD");
          this.uniqFieldId = this.stringUnique();
        },
        errorCaptured: function errorCaptured(err, vm, info) {
          this.logError({
            err: err,
            vm: vm,
            info: info
          });
        }
      });
    }
  }]);

  return MainSetting;
}();

export default new MainSetting();